import { useCallback } from 'react';
import { useLazyFetchAiContentAnalysisPdfQuery } from '../service';
import downloadPdfReport from '../downloadPdfReport';

export default function useDownloadAiContentAnalysisPdf() {
    const [fetchAiContentAnalysisPdf, { isFetching }] = useLazyFetchAiContentAnalysisPdfQuery();

    const downloadPdf = useCallback(
        (domain: string) => downloadPdfReport(() => fetchAiContentAnalysisPdf({ domain }).unwrap()),
        [fetchAiContentAnalysisPdf]
    );

    return {
        downloadPdf,
        isDownloadingPdf: isFetching,
    };
}
